import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requestButton: {
    id: 'react-components.9WRlF4',
    defaultMessage: 'Send',
  },
  requestFailed: {
    id: 'react-components.iMGl03',
    defaultMessage: 'Request failed',
  },
  requestSuccess: {
    id: 'react-components.s3FXF9',
    defaultMessage:
      'Request accepted! If an account matches that email address, you should receive an email with instructions on how to reset your password shortly.',
  },
  emailLabel: {
    id: 'react-components.sy+pv5',
    defaultMessage: 'Email',
  },
  emailMissing: {
    id: 'react-components.y2IH2u',
    defaultMessage: 'This should be a valid email address',
  },
  emailRequired: {
    id: 'react-components.KssJcX',
    defaultMessage: 'An email address is required',
  },
});
